import * as yup from "yup";

import { validationErrors } from "../../utils";

const { email } = validationErrors;

export default () =>
    yup.object().shape({
        email: yup
            .string()
            .trim()
            .email(email.invalid)
            .required(email.required),
    });
